var map = {
	"./1177646322.avif": "e117",
	"./1854ad51-54fc-444c-95b4-46e477e06a3a.3fdfc8c0dc484345ec889e2a20cc0cc4.webp": "ff51",
	"./25f477b0b0d0fe13c31cb01a3a816fa9.jpg": "d8d2",
	"./3b61f40c-04fe-4dee-aa8c-633a8d7c0d20.e0461a26035acce8cb7c71752bdf0496.webp": "3c48",
	"./Apple-WWDC23-Vision-Pro-glass-230605.jpg.landing-big_2x.jpg": "36e2",
	"./MULLIGANS..jpg": "e550",
	"./airpods.png": "f4e8",
	"./amanali-regalo.jpg": "a3ee",
	"./amanali-regalo.png": "a790",
	"./apple-vision-pro.png": "86de",
	"./apple-watch.png": "71bb",
	"./artboard-1-copia-2-100.jpg": "a0a4",
	"./artboard-1-copia-2-100_upscayl_4x_realesrgan-x4plus.png": "1af6",
	"./barra.png": "7c12",
	"./bg-sorteo-2024.jpg": "b520",
	"./bolsa-taylormade.png": "3a30",
	"./bpc.png": "6388",
	"./btn-sortear-vacio.png": "ccc7",
	"./btn-sortear.png": "31c5",
	"./cantalagua.jpg": "5321",
	"./cibc.png": "295f",
	"./club-de-golf-pachuca.jpg": "74de",
	"./club-de-golf-pachuca.webp": "2b1c",
	"./estancia-isla-navidad.jpg": "70fa",
	"./foursome-cocoyoc.jpg": "c795",
	"./foursome-ixtapa.jpg": "b1c4",
	"./foursome-tepeji.jpg": "fb1d",
	"./foursome-tepeji.png": "e42c",
	"./hostal-de-la-luz-regalo.jpg": "b207",
	"./hostal-de-la-luz-regalo.png": "f4a9",
	"./logo-club-de-golf-pachuca.webp": "7e3d",
	"./logo.png": "f826",
	"./nintendo.png": "a89f",
	"./nintendo2.png": "53f2",
	"./pantalla.png": "8aaa",
	"./playstation.png": "ba7e",
	"./primer-dia-179-edit.jpg": "587e",
	"./regalo2.png": "2148",
	"./sand-taylormade.png": "fdc7",
	"./santa-fe.jpg": "663a",
	"./santa-fe.webp": "7539",
	"./santafegolf-logotipo-positivo.svg": "1369",
	"./whisky.png": "ab05",
	"./xbox.png": "4ddc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ab4";